'use client'

import type React from 'react'
import Link from 'next/link'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Check } from 'lucide-react'

const carrierChecks = [
  'History - Medical, social, physical, psychological',
  'Mental Status Exam',
  'Understanding of Surrogacy',
  'Support system',
  'Plan after delivery',
  'Psychological Assessments',
]

const parentChecks = [
  'Detailed medical history',
  'Detailed social history',
  'Detailed physical history',
  'Detailed psychological history',
]

const SurrogacyEntails: React.FC = () => {
  return (
    <section className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
      <div className="grid gap-5 sm:gap-6 md:grid-cols-2">
        {/* Gestational Carrier */}
        <Card className="shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-base font-semibold sm:text-lg lg:text-xl">
              Evaluations for the Gestational Carrier
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2.5 sm:space-y-3">
              {carrierChecks.map((item) => (
                <li key={item} className="flex items-start gap-2.5 sm:gap-3">
                  <Check
                    aria-hidden
                    className="mt-0.5 h-4 w-4 shrink-0 sm:h-5 sm:w-5"
                  />
                  <span className="text-sm sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        {/* Intended Parents */}
        <Card className="shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-base font-semibold sm:text-lg lg:text-xl">
              Evaluations for the Intended Parents
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2.5 sm:space-y-3">
              {parentChecks.map((item) => (
                <li key={item} className="flex items-start gap-2.5 sm:gap-3">
                  <Check
                    aria-hidden
                    className="mt-0.5 h-4 w-4 shrink-0 sm:h-5 sm:w-5"
                  />
                  <span className="text-sm sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>

      <p className="mt-5 text-sm text-muted-foreground sm:mt-6 sm:text-base">
        <Link
          href="/surrogate-psychological-evaluation"
          className="font-medium text-emerald-700 underline underline-offset-4 hover:text-emerald-800"
        >
          Learn what a surrogate psychological evaluation involves
        </Link>
        , including what clinicians assess and what to expect.
      </p>
    </section>
  )
}

export default SurrogacyEntails
